#import "../fragments/account-duplicate-fragment.graphql"

query GetAccountDuplicateStatus($id: ID!) {
    account(id: $id) {
        ...AccountDuplicateFragment
    }
}
